import { callService, loadWebtexte } from "@phoenixreisen/gateway";
export function getTravs(booking) {
    return booking?.["buchung/reiseteilnehmer"] ?? [];
}
export function getTravsWithHTABooked(booking) {
    const travs = getTravs(booking);
    return travs.filter((trav) => trav["reiseteilnehmer/hta?"]);
}
export function hasHTABooked(booking) {
    return getTravsWithHTABooked(booking).length > 0;
}
export function hasHTAData(trav) {
    if (!trav["reiseteilnehmer/haustuerabholung"]) {
        return false;
    }
    const keys = Object.keys(trav["reiseteilnehmer/haustuerabholung"]);
    return keys.every((key) => {
        const optionals = ["hta/bemerkung", "hta/erfassungszeitpunkt"];
        return (optionals.includes(key) || !!trav["reiseteilnehmer/haustuerabholung"][key]);
    });
}
export function getTravsWithHTAFilled(booking) {
    const travs = getTravs(booking);
    return travs.filter(hasHTAData);
}
export function hasExtraDriveBackOptionBooked(trav) {
    return trav["reiseteilnehmer/hta2?"];
}
export function hasExtraDriveBackOptionFilled(trav) {
    if (!trav["reiseteilnehmer/haustuerabholung-rueck"]) {
        return false;
    }
    const keys = Object.keys(trav["reiseteilnehmer/haustuerabholung-rueck"]);
    return keys.every((key) => {
        const optionals = ["hta/bemerkung", "hta/erfassungszeitpunkt"];
        return (optionals.includes(key) ||
            !!trav["reiseteilnehmer/haustuerabholung-rueck"][key]);
    });
}
export async function save(data, travid, rechnr, jwt, type) {
    const serviceName = type === "catch-up"
        ? "meinphoenixservices.haustuerabholung.hta-daten-aendern"
        : "meinphoenixservices.haustuerabholung.htr-daten-aendern";
    const serviceType = type === "catch-up" ? "hta-daten-aendern" : "htr-daten-aendern";
    return callService(serviceName, {
        type: serviceType,
        "rech-nr": rechnr,
        "tn-nr": travid,
        strasse: data.street,
        plz: data.postalcode,
        landcode: data.country,
        ort: data.city,
        telefon: data.phone,
        jwt: jwt,
        bemerkung: null,
    });
}
export async function getWebtexte() {
    const categories = [
        "hta__ueberschrift",
        "hta__uebersicht__einleitung",
        "hta__formular__einleitung",
        "hta__formular__hinfahrt",
        "hta__formular__rueckfahrt",
        "hta__formular__hinweis_land",
        "hta__formular__hinweis_telefon",
        "hta__formular__readonly_grund",
        "hta_rueck__formular__readonly_grund",
    ];
    return loadWebtexte(categories, "webtexte.hta");
}
